// This file is generated by a script. Do not edit this file directly.
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from 'react';
export var InfoSolid = function InfoSolid(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#infosolid-a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M10 20a10 10 0 1 0 0-20 10 10 0 0 0 0 20m-1.562-6.875h.937v-2.5h-.937a.935.935 0 0 1-.938-.937c0-.52.418-.938.938-.938h1.874c.52 0 .938.418.938.938v3.437h.313c.519 0 .937.418.937.938 0 .519-.418.937-.937.937H8.437a.935.935 0 0 1-.937-.937c0-.52.418-.938.938-.938M10 5a1.25 1.25 0 1 1 0 2.5A1.25 1.25 0 0 1 10 5"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "infosolid-a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M0 0h20v20H0z"
  }))));
};
